import React from 'react'
import PropTypes from 'prop-types'
import { FormattedHTMLMessage } from 'sb-react-intl'

import Link from 'components/ui/Link/Link'

import messages from './messages'
import s from './UserSummary.scss'


const UserSummary = ({ url, reviewsTotal, likeTotal, dislikeTotal, shippedCount }) => {
  const reviewsUrl   = `${url}?reviews`
  const deliveredUrl = `${url}?delivered`

  return (
    <div className={s.summary}>
      <Link className={s.summaryLink} toOLD={reviewsUrl} customColor>
        <FormattedHTMLMessage tag="div" {...messages.reviews} values={{ reviewsTotal }} />
      </Link>
      <FormattedHTMLMessage tag="div" {...messages.likes} values={{ likeTotal }} />
      <FormattedHTMLMessage tag="div" {...messages.dislikes} values={{ dislikeTotal }} />
      <Link className={s.summaryLink} toOLD={deliveredUrl} customColor>
        <FormattedHTMLMessage tag="div" {...messages.productsReceived} values={{ shippedCount }} />
      </Link>
    </div>
  )
}

UserSummary.propTypes = {
  url: PropTypes.string.isRequired,
  reviewsTotal: PropTypes.number.isRequired,
  likeTotal: PropTypes.number.isRequired,
  dislikeTotal: PropTypes.number.isRequired,
  shippedCount: PropTypes.number.isRequired,
}


export default UserSummary
